<template>
  <el-container class="layout-container">
    <!-- 左侧菜单 -->
    <el-aside width="200px">
      <!--element-plus的菜单标签-->
      <el-menu active-text-color="#ffd04b" background-color="#232323" text-color="#fff" router>

        <el-submenu index="carbon">
          <template slot="title">
            <span style="font-size: 22px">开源数据</span>
          </template>
          <el-menu-item index="/dataTable/cea">
            <span style="font-size: 16px">碳排放配额</span>
          </el-menu-item>
          <el-menu-item index="/dataTable/co2">
            <span style="font-size: 16px">二氧化碳</span>
          </el-menu-item>
          <el-menu-item index="/dataTable/ch4">
            <span style="font-size: 16px">甲烷数据</span>
          </el-menu-item>
        </el-submenu>

        <el-submenu index="xjtu">
          <template slot="title">
            <span style="font-size: 22px">零碳园区</span>
          </template>
          <el-menu-item index="/dataTable/els">
            <span style="font-size: 16px">电气系统</span>
          </el-menu-item>
          <el-menu-item index="/dataTable/hvac">
            <span style="font-size: 16px">暖通系统</span>
          </el-menu-item>
          <el-menu-item index="/dataTable/hydrogen">
            <span style="font-size: 16px">氢能系统</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <!-- 右侧主区域 -->
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>


</template>

<script>

export default {
  data() {
    return {}
  },
  components: {},
  computed: {},
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
.data-table-page::v-deep {
  padding: 20px;

  .el-table,
  .el-table__expanded-cell,
  .el-table tr,
  .el-table .el-table__expanded-cell,
  .el-table th.el-table__cell {
    background: transparent;
  }

  .el-table,
  .el-table thead {
    color: #fff;
  }



  .el-table__body {
    tr:hover>td {
      color: rgba(29, 35, 47, 1);
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-next,
  .el-pagination .btn-prev {
    background: transparent;
    color: #fff;
  }

  .el-pager li.active {
    background: #fff;
    color: rgba(29, 35, 47, 1);
  }

}

.layout-container {
  height: 100%;

  .el-aside {
    background-color: #232323;


    .el-menu {
      border-right: none;
    }
  }
}
</style>
